import type { PropsWithChildren } from "react";
import { useEffect, useState } from "react";

const ClientOnly = ({ children }: PropsWithChildren): JSX.Element | null => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return <>{children}</>;
};

export default ClientOnly;
